import React, { useEffect } from "react";
import { X } from "lucide-react";

const Modal = ({ showModal, closeModal, content }) => {
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  return showModal && <div className="modal">{content}</div>;
};

export default Modal;
